// Which plan gets live Build controls.
//
// Pure and dependency-free on purpose: the hook that uses it pulls in the
// Supabase client, which needs env at import time and can't be loaded in a
// plain unit test. This is the part worth testing, so it lives apart from that.

export interface PlanCandidate {
  id: string;
  role: "user" | "assistant";
  plan?: unknown;
  committedWorkflowId?: string;
}

/**
 * The newest assistant turn carrying a plan nobody has built yet, or null.
 *
 * Returning null once the newest plan is built is deliberate: revisions
 * supersede each other, so an older card must never become buildable again
 * just because the newest one was committed.
 */
export function findPendingPlanId(
  messages: ReadonlyArray<PlanCandidate>,
): string | null {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const message = messages[i];
    if (message.role !== "assistant" || !message.plan) continue;
    return message.committedWorkflowId ? null : message.id;
  }
  return null;
}
